import x7url from '@/utils/x7url'

/**
 * 获取请求的baseURL
 */
export const getFetchBaseURL = () => {
  let baseURL = `https://${x7url.getServerHost('open')}`
  if (import.meta.env.DEV) {
    baseURL = '/devApi'
  }
  return baseURL
}
